import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "align-left-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4 3C3.58579 3 3.25 3.37219 3.25 3.8313C3.25 4.29042 3.58579 4.66261 4 4.66261H20C20.4142 4.66261 20.75 4.29042 20.75 3.8313C20.75 3.37219 20.4142 3 20 3H4Z" }, null, -1),
    _createElementVNode("path", { d: "M4 8.54202C3.58579 8.54202 3.25 8.9142 3.25 9.37332C3.25 9.83244 3.58579 10.2046 4 10.2046H16C16.4142 10.2046 16.75 9.83244 16.75 9.37332C16.75 8.9142 16.4142 8.54202 16 8.54202H4Z" }, null, -1),
    _createElementVNode("path", { d: "M3.25 14.9153C3.25 14.4562 3.58579 14.084 4 14.084H20C20.4142 14.084 20.75 14.4562 20.75 14.9153C20.75 15.3745 20.4142 15.7466 20 15.7466H4C3.58579 15.7466 3.25 15.3745 3.25 14.9153Z" }, null, -1),
    _createElementVNode("path", { d: "M4 19.6261C3.58579 19.6261 3.25 19.9982 3.25 20.4574C3.25 20.9165 3.58579 21.2887 4 21.2887H12C12.4142 21.2887 12.75 20.9165 12.75 20.4574C12.75 19.9982 12.4142 19.6261 12 19.6261H4Z" }, null, -1)
  ])))
}
export default { render: render }